import { createElement } from 'react';
import { Workflow } from 'lucide-react';
import catalog from '@/data/catalog.json';
import { getIcon } from '@/lib/iconMap';
import { CommunityIcon } from '@/components/icons/CommunityIcon';
import type { LinkItem, LinkSection } from '@/data/links';

/** Serialized inventory shared by the offline UI, initial HTML, schema and llms.txt. */
export const curatedFallbackSections: LinkSection[] = catalog.map((section) => ({
  id: section.id,
  title: section.title,
  emoji: createElement(CommunityIcon, { size: 22 }),
  links: section.links.map((item) => ({
    ...item,
    icon: item.icon === 'Workflow' ? Workflow : getIcon(item.icon),
    animation: item.animation as LinkItem['animation'],
    tag: item.tag as LinkItem['tag'],
  })),
}));

/** DB content is authoritative: never drop unknown sections, rows or admin edits. */
export function shapeCatalogue<T>(sections: T[]): T[] {
  return sections;
}
